// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
// Material Kit 2 React components
import MKBox from "components/MKBox";
import CardMedia from "@mui/material/CardMedia";

// Material Kit 2 React examples
//import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";
import CenteredBlogCard from "examples/Cards/BlogCards/CenteredBlogCard";
import MKTypography from "components/MKTypography";
import team2 from "assets/images/team2.jpg";
import aim from "assets/images/aim.jpg";

function Information() {
  return (
    <MKBox component="section" py={4}>
      <Container>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} lg={6}>
            <MKTypography variant="h3"> Who are we? </MKTypography>
            <MKTypography variant="body1" mt={1} mb={0}>
              We are located on the beautiful beach of Mount Lavinia the only beach that is close
              and accessible for a nice sea bath close to the Capital of Sri Lanka. Just 11km and
              around 20Min away south of Colombo. There are 13 wrecks and 15 reef sites that you
              could choose to dive from 1km to 25km from the shore 10 to 40 minute boat ride to your
              choice of dive sites depending on the weather. Also are some nice beach restaurants
              with delicious sea food menus to select right after those wonderful dives.you could
              relax the evening on the beach having your favorite cocktails and chilled beer. Dive
              shop is in walking distance to some of the star class hotels as well as budget hotels
              for accommodation. Our friendly staff is well experienced in the local diving industry
              as well as city to provide you with best possible service. Also we consider our divers
              as a big family which we have one common goal is to explore the deep blue Ocean. It’s
              our pleasure to help you in any other needs and information that you want in touring
              around our beautiful country.
            </MKTypography>
          </Grid>
          <Grid item xs={12} lg={5} sx={{ ml: "auto", mt: { xs: 3, lg: 0 } }}>
            <Card sx={{ maxWidth: 500, borderRadius: 3, boxShadow: 3 }}>
              <CardMedia
                component="img"
                image={team2}
                alt="Scuba Adicts"
                sx={{ height: 350, objectFit: "cover" }}
              />
            </Card>
          </Grid>
        </Grid>
      </Container>
      <Container>
        <Grid container spacing={20} alignItems="center">
          <Grid item xs={12} lg={5} sx={{ ml: "auto", mt: { xs: 3, lg: 0 } }}>
            <CenteredBlogCard
              image={aim}
              height="300px"
              title="After all every ones on holiday in the beach. So Chill..!!! Come & have Fun…!!!"
              //description="Website visitors today demand a frictionless user expericence — especially when using search. Because of the hight standards."
              action={{
                type: "internal",
                route: "../pages/landing-pages/contact-us",
                color: "info",
                label: "Find out more",
              }}
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <MKTypography variant="h3" mt={8} mb={0}>
              Our Aim...
            </MKTypography>
            <MKTypography variant="body1" mt={4} mb={0}>
              Our staff is very happy to work in the diving industry as it’s a passion and something
              that we love doing as a hobby. Our boats are scheduled to leave the dive center around
              7.30am and will be back a shore after two dives around 1pm. But will make slight
              changes if needed by you with discussing with the other divers and expect our divers
              to respect this mutual understanding. The dive industry is a big busy industry create
              a stressful environment to make profits around the world. Our management prefer to
              allow our staff members to the job they love in a non-stressful environment. Taking it
              nice and easy, so our Main priority, The Dive Guests can have a nice relaxed fun
              atmosphere without been stressed for anything at all. We prefer to have and serve
              minimum number of divers so we could serve you better. In return to provide you a
              memorable easy going relaxed dive experience than any other. So everyone’s happy and
              having fun keeping in mind that safety comes first.
            </MKTypography>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Information;
